import React, { useState, useEffect } from 'react';
import SelectableIntegrationCard from '../Cards/SelectableIntegrationCard';
import AvailableFlowCard from '../Cards/AvailableFlowCard';
import SelectablePackageCard from '../Cards/SelectablePackageCard';
import { apiRequest } from '../../api/index';
import {createFlowWithPackages, getUserData} from '../../api/userData';
import {useParams} from "react-router-dom";

const CreateNewFlowModal = ({ isOpen, onClose, refreshFlows }) => {
  const { id } = useParams();
  const [userData, setUserData] = useState(null);
  const [integrations, setIntegrations] = useState([]);
  const [flows, setFlows] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [selectedPackages, setSelectedPackages] = useState([]);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Состояние для хранения дополнительных данных выбранных пакетов
  const [packageData, setPackageData] = useState({});
  
  // Обновление данных пакета
  const handlePackageUpdate = (updatedPackage) => {
    setPackageData(prev => ({
      ...prev,
      [updatedPackage.id]: updatedPackage
    }));
  };

  // Состояние для отслеживания загрузки данных
  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (!isOpen || isLoading || isDataLoaded) return;
    
    const loadInitialData = async () => {
      setIsLoading(true);
      try {
        // Загружаем данные пользователя
        // const userData = await getAuthenticatedUser();
        const userData = await apiRequest(`users/${id}/profile`, 'GET');
        // console.log("userData: ", userData);
        setUserData(userData);

        // Загружаем интеграции пользователя
        const integrationsData = await apiRequest(`integrations/${id}/list`, 'GET');
        const userFlowsData = await getUserData(id)

        console.log("userFlowsData: ", userFlowsData);

        // Фильтруем интеграции, убирая те, которые уже есть у пользователя
        // const userIntegrationIds = userFlowsData?.flows?.map(flow => flow.integration_id) || [];
        // const filteredIntegrations = integrationsData.data.integrations.filter(integration => !userIntegrationIds.includes(integration.id));
        //
        // setIntegrations(filteredIntegrations || []);
        // const updatedIntegrations = (integrationsData.data.integrations || []).map(integration => {
        //   const integrationFlows = userFlowsData?.filter(flow => flow.integration_id === integration.id) || [];
        //     return {
        //       ...integration,
        //       flows: integrationFlows
        //     };
        // });
        // setIntegrations(updatedIntegrations);
        setIntegrations(integrationsData.data.integrations || []);

        // Загружаем доступные потоки
        const flowsData = await apiRequest('flow-guides', 'GET');

        // Фильтруем потоки, убирая те, которые уже есть у пользователя
        const userFlowIds = userFlowsData?.flows?.map(flow => flow.flow_guide_id) || [];
        const filteredFlows = flowsData.data.filter(flow => !userFlowIds.includes(flow.id));

        setFlows(filteredFlows);
        
        // Загружаем пакеты
        const packagesData = await apiRequest('paks', 'GET');
        setPackages(packagesData.data || []);
        
        // Устанавливаем флаг, что данные загружены
        setIsDataLoaded(true);
      } catch (error) {
        console.error('Ошибка при загрузке данных:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    loadInitialData();
  }, [isOpen, isLoading, isDataLoaded]);

  if (!isOpen) return null;

  // Показываем индикатор загрузки, пока данные не загружены
  if (isLoading || !isDataLoaded) {
    return (
      <div className={isMobile ? "modal-overlay-mobile" : "modal-overlay"} onClick={onClose}>
        <div 
          className="modal fullscreen bottom-right open"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            {isMobile && (
              <button className="modal-close-btn" onClick={onClose} aria-label="Закрыть">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}
            <h3>Создание нового потока</h3>
          </div>
          <div className="modal-body">
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Загрузка данных...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleCreateFlow = async () => {
    try {
      // Формируем полные данные для выбранных пакетов
      const selectedPackagesWithDetails = selectedPackages.map(pkg => {
        const details = packageData[pkg.id] || {};
        return {
          ...pkg,
          selectedRegions: details.selectedRegions || [],
          limit: details.limit || 100,
          noWeekend: details.noWeekend || false
        };
      });
      
      // Вызываем метод создания потока с пакетами
      const result = await createFlowWithPackages(
        selectedIntegration,
        [selectedFlow],
        selectedPackagesWithDetails,
        userData
      );
      
      // Обработка результата
      if (result.success) {
        // Обновляем потоки
        refreshFlows();
        // Закрываем модальное окно при успешном создании
        onClose();
      }
    } catch (error) {
      console.error('Ошибка при создании потока:', error);
    }
  };

  return (
    <div className={isMobile ? "modal-overlay-mobile" : "modal-overlay"} onClick={onClose}>
      <div 
        className="modal fullscreen bottom-right open"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          {isMobile && (
            <button className="modal-close-btn" onClick={onClose} aria-label="Закрыть">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          )}
          <h3>Создание нового потока</h3>
        </div>
        <div className="modal-body">
          
          <div className="create-flow-steps">
            <div className="flow-step">
              <h4>Привяжите поток интеграции *</h4>
              <div className="integrations-list">
                {integrations.map(integration => (
                  <SelectableIntegrationCard 
                    key={integration.id} 
                    integration={integration} 
                    onSelect={(integration) => setSelectedIntegration(integration)} 
                    isSelected={selectedIntegration && selectedIntegration.id === integration.id}
                  />
                ))}
              </div>
            </div>
            
            <div className="flow-step">
              <h4>Выберите поток *</h4>
              <div className="flows-grid">
                {flows.map(flow => (
                  <AvailableFlowCard 
                    key={flow.id} 
                    flow={flow} 
                    onSelect={() => setSelectedFlow(flow)}
                    isSelected={selectedFlow && selectedFlow.id === flow.id}
                  />
                ))}
              </div>
            </div>
            
            <div className="flow-step">
              <h4>Выберите пакет *</h4>
              <div className="packages-list">
                {packages.map(pkg => (
                  <SelectablePackageCard 
                    key={pkg.id} 
                    package={pkg} 
                    onSelect={(selectedPackage) => {
                      const isSelected = selectedPackages.some(p => p.id === pkg.id);
                      if (isSelected) {
                        setSelectedPackages(selectedPackages.filter(p => p.id !== pkg.id));
                        // Удаляем данные пакета при отмене выбора
                        setPackageData(prev => {
                          const newPackageData = {...prev};
                          delete newPackageData[pkg.id];
                          return newPackageData;
                        });
                      } else {
                        setSelectedPackages([...selectedPackages, selectedPackage]);
                      }
                    }} 
                    isSelected={selectedPackages.some(p => p.id === pkg.id)}
                    onPackageUpdate={handlePackageUpdate}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button 
            className="btn btn-primary-filled"
            onClick={handleCreateFlow}
            disabled={!selectedIntegration || !selectedFlow || selectedPackages.length === 0}
          >
            Создать новый поток
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateNewFlowModal;